import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useFirmMode } from '../contexts/FirmModeContext';

const isLocalhost = () =>
  typeof window !== 'undefined' && /localhost|127\.0\.0\.1/.test(window.location.hostname || '');

/**
 * Protects routes so they require either normal Ydim login or a valid firm (Arsheef) session.
 * Firm-mode users (arrived via arsheef_token) are treated as authenticated for these pages.
 */
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const { isFirmMode, firmCheckDone } = useFirmMode();

  if (process.env.NODE_ENV === 'development' || isLocalhost()) {
    console.log('[ProtectedRoute]', { isLoading, isAuthenticated, firmCheckDone, isFirmMode });
  }

  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
      }}>
        <div style={{
          color: 'white',
          fontSize: '1.2rem',
          fontWeight: '500'
        }}>
          Loading...
        </div>
      </div>
    );
  }

  if (isAuthenticated) {
    if (process.env.NODE_ENV === 'development' || isLocalhost()) console.log('[ProtectedRoute] Allowing: normal auth');
    return children;
  }

  // Wait for firm-mode check (URL token or sessionStorage) before redirecting to login
  if (!firmCheckDone) {
    if (process.env.NODE_ENV === 'development' || isLocalhost()) console.log('[ProtectedRoute] Showing loading: firm check not done');
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
      }}>
        <div style={{
          color: 'white',
          fontSize: '1.2rem',
          fontWeight: '500'
        }}>
          Loading...
        </div>
      </div>
    );
  }

  if (isFirmMode) {
    if (process.env.NODE_ENV === 'development' || isLocalhost()) console.log('[ProtectedRoute] Allowing: firm mode');
    return children;
  }

  if (process.env.NODE_ENV === 'development' || isLocalhost()) console.log('[ProtectedRoute] Redirecting to /login');
  return <Navigate to="/login" replace />;
};

export default ProtectedRoute;
